<template>
    <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :width="size"
        :height="size"
        :class="{ 'animate-spin': name === 'loader' }"
    >
        <circle
            v-if="name === 'loader'"
            cx="12"
            cy="12"
            r="9"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-dasharray="42"
            stroke-dashoffset="14"
        />
        <path
            v-else-if="pathDef"
            :d="pathDef"
            stroke="currentColor"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    size: {
        type: Number,
        default: 24,
    },
    strokeWidth: {
        type: Number,
        default: 1.5,
    },
});

const icons = {
    'chevron-left': 'M15 18l-6-6 6-6',
    'chevron-right': 'M9 18l6-6-6-6',
    plus: 'M12 5v14M5 12h14',
    calendar: 'M8 2v3M16 2v3M3 8h18M5 4h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2z',
    'chart-bar': 'M3 3v18h18M7 16v-4M12 16V8M17 16v-7',
};

const pathDef = computed(() => icons[props.name]);
</script>
